// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"427":"90d83abf","925":"550f6333","935":"ca4233d0"}[chunkId] + ".css";
};